module.exports = __webpack_public_path__ + "static/media/Retângulo 714.addd5cc3.png";